import OnboardingPage from './OnboardingPage';

const exports = {
    Page: OnboardingPage,
};

export default exports;
export { default as OnboardingBanner, LandingHold } from './OnboardingBanner';
export { default as FinishSetupCard } from './FinishSetupCard';
export { ONBOARDING_PATH, OnboardingStatusProvider, useOnboardingLanding, useOnboardingStatus } from './OnboardingStatus';
export { default as SetupGate } from './SetupGate';
export { stashSetupFlag } from './setupFlag';
